import { useRef, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import styles from './FJVoiceSetting.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import FJSelectWithSearch from './FJSelectWithSearch/FJSelectWithSearch';
import FJVoiceDropList from './FJVoiceDropList/FJVoiceDropList';
import FJResSliderInput from '../../../common/components/FJSlider/FJResSliderInput';
import FJSwitchButton from '../../../common/components/FJSwitchButton/FJSwitchButton';
const FJVoiceSetting = props => {
    const {
        languageList,
        voiceList,
        voiceValue,
        voiceStyleList,
        voiceStyleValue,
        voiceSpeed,
        voicePitch,
        languageValue,
        onChangeVoice,
        onChangeVoiceStyle,
        onChangeVoiceSpeed,
        onChangeVoicePitch,
        onLanguageValueChange,
        stopPreview,
        voiceSettingActive,
        onVoiceSettingActiveChange,
    } = props;
    const sliderSpeedRef = useRef(null);
    const sliderPitchRef = useRef(null);

    useEffect(() => {
        sliderSpeedRef.current && sliderSpeedRef.current.updateSlider(voiceSpeed);
    }, [voiceSpeed]);

    useEffect(() => {
        sliderPitchRef.current && sliderPitchRef.current.updateSlider(voicePitch);
    }, [voicePitch]);
    const voiceListScrollHeight = useMemo(() => {
        const voiceListLength = voiceList.length;
        if (voiceListLength > 5) {
            return 220;
        } else {
            return 40 * voiceListLength + 22;
        }
    }, [voiceList]);
    const voiceStyleListScrollHeight = useMemo(() => {
        const voiceStyleListLength = voiceStyleList.length;
        if (voiceStyleListLength > 5) {
            return 220;
        } else {
            return 36 * voiceStyleListLength + 21;
        }
    }, [voiceStyleList]);
    const _getComp = () => {
        // if (!voiceSettingActive) return null;
        return (
            <div className={styles.voice_setting_container}>
                <div className={classNames(styles.title, styles.margin_top_14)}>{FJLocalStore._('language')}</div>
                <FJSelectWithSearch
                    list={languageList}
                    onLanguageValueChange={onLanguageValueChange}
                    value={languageValue}
                    zIndex={1001}
                />
                <ul className={classNames(styles.setting_line)}>
                    <li className={styles.voice_item}>
                        <div className={classNames(styles.title, styles.margin_bottom8)}>{FJLocalStore._('voice')}</div>
                        <FJVoiceDropList
                            list={voiceList}
                            id={voiceValue}
                            onClick={onChangeVoice}
                            overlayStyle={{ height: voiceListScrollHeight, width: '320px' }}
                            hasIcon={true}
                            stopPreview={stopPreview}
                            zIndex={1001}
                        />
                    </li>
                    <li className={styles.voice_item}>
                        <div className={classNames(styles.title, styles.margin_bottom8)}>
                            {FJLocalStore._('speaking-style')}
                        </div>
                        <FJVoiceDropList
                            list={voiceStyleList}
                            id={voiceStyleValue}
                            onClick={onChangeVoiceStyle}
                            overlayStyle={{ height: voiceStyleListScrollHeight, width: '320px' }}
                            hasIcon={true}
                            stopPreview={stopPreview}
                            disabled={voiceStyleList.length === 0}
                            isShowGeneral={true}
                            zIndex={1001}
                        />
                    </li>
                </ul>

                <ul className={classNames(styles.setting_line)}>
                    <li className={styles.silder_item}>
                        <FJResSliderInput
                            ref={sliderSpeedRef}
                            sliderID='speechSpeedSlider'
                            callback={data => onChangeVoiceSpeed(data.value)}
                            name={FJLocalStore._('speaking-speed')}
                            labelClass={styles.title}
                            min={0}
                            max={3}
                            hasUnit={false}
                            value={voiceSpeed}
                            step={0.1}
                            defaultValue={1}
                        />
                    </li>
                    <li className={styles.silder_item}>
                        <FJResSliderInput
                            ref={sliderPitchRef}
                            sliderID='speechPitchSlider'
                            callback={data => onChangeVoicePitch(data.value)}
                            name={FJLocalStore._('pitch')}
                            labelClass={styles.title}
                            min={0}
                            max={2}
                            step={0.1}
                            hasUnit={false}
                            value={voicePitch}
                            defaultValue={1}
                        />
                    </li>
                </ul>
            </div>
        );
    };
    return (
        <div className={classNames(styles.container, voiceSettingActive && styles.active)}>
            <div className={styles.header}>
                <div className={classNames(styles.header_title)}>{FJLocalStore._('voice-settings')}</div>
                <FJSwitchButton active={voiceSettingActive} onChange={onVoiceSettingActiveChange} type='gradient' />
            </div>
            {_getComp()}
        </div>
    );
};

FJVoiceSetting.propTypes = {
    languageList: PropTypes.array.isRequired,
    voiceList: PropTypes.array.isRequired,
    voiceValue: PropTypes.string.isRequired,
    voiceStyleList: PropTypes.array.isRequired,
    languageValue: PropTypes.string.isRequired,
    voiceStyleValue: PropTypes.string.isRequired,
    voiceSpeed: PropTypes.number.isRequired,
    voicePitch: PropTypes.number.isRequired,
    onChangeVoice: PropTypes.func.isRequired,
    onChangeVoiceStyle: PropTypes.func.isRequired,
    onChangeVoiceSpeed: PropTypes.func.isRequired,
    onChangeVoicePitch: PropTypes.func.isRequired,
    onLanguageValueChange: PropTypes.func.isRequired,
    stopPreview: PropTypes.func.isRequired,
    voiceSettingActive: PropTypes.bool.isRequired,
    onVoiceSettingActiveChange: PropTypes.func.isRequired,
};
export default FJVoiceSetting;
